import { pgTable, text, boolean, timestamp, integer, index, foreignKey, jsonb } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import type { TriggerAction, TriggerConditions } from '@masters-club/types';
import { triggerEvent } from './enums';

// foreignKey остаётся импортированным для TriggerLog → Trigger FK ниже.

/**
 * Structural-тип SegmentDefinition для $type<>() jsonb-колонки.
 * Не импортируем @masters-club/validation чтобы избежать цикла (validation → db).
 * Совпадает по форме с SegmentDefinition в @masters-club/validation.
 */
type SegmentDefinitionShape = {
  groupsOp?: 'AND' | 'OR';
  groups: Array<{
    conditionsOp?: 'AND' | 'OR';
    conditions: Array<{ field: string; operator: string; value?: unknown }>;
  }>;
};

// FK на UserSegment объявлен в SQL-миграции 0090_trigger_audience.sql.
// В Drizzle schema используем sql-references напрямую, чтобы избежать
// циклической зависимости trigger ↔ user-segment ↔ admin ↔ ...

export const trigger = pgTable('Trigger', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  name: text().notNull(),
  eventType: triggerEvent().notNull(),
  conditions: jsonb().$type<TriggerConditions | null>(),
  actions: jsonb().$type<TriggerAction[]>().notNull(),
  delay: integer(),
  isActive: boolean().default(true).notNull(),
  audienceDefinition: jsonb().$type<SegmentDefinitionShape | null>(),
  audienceSegmentId: integer(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
}, (table) => [
  index('Trigger_eventType_idx').using('btree', table.eventType.asc().nullsLast()),
  index('Trigger_isActive_idx').using('btree', table.isActive.asc().nullsLast()),
  index('Trigger_audienceSegmentId_idx').using('btree', table.audienceSegmentId.asc().nullsLast()),
]);

export const triggerLog = pgTable('TriggerLog', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  triggerId: integer().notNull(),
  userId: integer(),
  input: jsonb(),
  output: jsonb(),
  success: boolean().notNull(),
  error: text(),
  executedAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  index('TriggerLog_executedAt_idx').using('btree', table.executedAt.asc().nullsLast()),
  index('TriggerLog_success_idx').using('btree', table.success.asc().nullsLast()),
  index('TriggerLog_triggerId_idx').using('btree', table.triggerId.asc().nullsLast()),
  foreignKey({
    columns: [table.triggerId],
    foreignColumns: [trigger.id],
    name: 'TriggerLog_triggerId_fkey'
  }).onUpdate('cascade').onDelete('cascade'),
]);
